import React from 'react';
import GlobalDataStore from './stores';

const GlobalContext = React.createContext(new GlobalDataStore());
const ForSpouseContext = React.createContext(false);

export { GlobalContext, ForSpouseContext };
